import { Nullable } from "@/types/util"
import { MD5 } from "object-hash"

import { nowMillis } from "./date-utils"

export class MemoryCache<T> {
  private cache: Map<string, { expires_at?: number; value: T }> = new Map()

  get(key: string): Nullable<T> {
    const cached = this.cache.get(key)
    if (cached && (!cached.expires_at || cached.expires_at > nowMillis())) {
      return cached.value
    } else {
      return null
    }
  }

  set(key: string, value: T, expiresIn?: number) {
    this.cache.set(key, {
      value: value,
      expires_at: expiresIn ? nowMillis() + expiresIn : undefined,
    })
  }

  // has key and not expired
  has(key: string): boolean {
    const cached = this.cache.get(key)
    return !!cached && (!cached.expires_at || cached.expires_at > nowMillis())
  }

  del(key: string) {
    this.cache.delete(key)
  }

  objToKey(obj: NonNullable<unknown>): string {
    return MD5(obj)
  }

  clear() {
    this.cache.clear()
  }
}
